import type { ICountry } from '~/types/country/models'

/**
 * Enrich a country from the API with the `label` every select value needs.
 *
 * Mirrors State() — and exists for the same reason. A country reaches an input
 * field by two different paths, and only one of them used to add a label:
 *   - as a select's ITEMS, via setItemsForSelect(labelPropertyName: 'name'),
 *     which labels each entry, and
 *   - as a field's DEFAULT VALUE, via getCountry(), which returned the raw API
 *     object.
 * A raw country therefore failed `isSelectItem` (it wants `id` AND `label`), so
 * `hasSpecficSelectItemValue` threw the moment anything asserted on the value —
 * which is what broke saving a new company once address validation started
 * calling isDomesticAddress().
 */
export function Country(o: ICountry): ICountry {
  const fn = '[cynqueModules/dataObjects/Country.ts] Country |'
  if (!o) {
    throw new Error(`${fn} Country called with falsey country`)
  }

  const obj = { ...o }
  obj.label = o.name
  return obj
}
